import { Injectable } from '@angular/core';
import { IDatepickerLocaleValues } from 'ng2-semantic-ui';
import { ToastrService } from 'ngx-toastr';
import { title } from 'process';
import { ApiService } from './api.service';
import { companyInfo } from './business-model-interfaces/application';
import { UserSessionService } from './user-session.service';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  // START ======================== ENVIRONMENT SETTINGS (PRODUCTION / TESTING / DEVELOPMENT) =========================== //
  //                                                                                                                      //
  //                                                   *** IMPORTANT ***                                                  //
  //                                                                                                                      //
  // ==================================================================================================================== //
  envMode = 'PRODUCTION';
  // envMode = 'TESTING';
  // envMode = 'DEVELOPMENT';
  // END ========================== ENVIRONMENT SETTINGS (PRODUCTION / TESTING / DEVELOPMENT) =========================== //

  ataSeparator = '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -';

  // VERTIS DEV SERVER
  fileProxyUrl = 'https://63-250-57-22.cloud-xip.com/primo-api/public/proxy-server.php';
  emailLogoUrl = 'https://63-250-57-22.cloud-xip.com/assets/img/vertis-logo-inverted.png';

  loginSalt: string = '0vertis1project3salt';

  // GERAL
  currency='EUR';
  currencySymbol='€';

  percent = {
    icon: '%'
  }

  pdf = {
    proxyTarget: '_blank',
    forceProxy: true
  }
  pdfStyle = {
    carta: {
      margin: { 
        top: 27, 
        bottom: 40, 
        right: '1.5cm', 
        left: '1.5cm' 
      }
    }
  }


  datePipe = {
    dateExt: 'dd \'de\' MMMM \'de\' y',
    monthYearExt: 'MMMM \'de\' y'
  }

  meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
  mesesAbrevDot = ['Jan.','Fev.','Mar.','Abr.','Mai.','Jun.','Jul.','Ago.','Set.','Out.','Nov.','Dez.'];

  menuArrOld = [
    { canAccess: true, key: 'CONDOMINIOS', icon: 'mdi mdi-home-city-outline', name: 'Condomínios', nowrap: false, route: '/condominios', routes: ['/condominios/fraccoes', '/condominios/contas', '/condominios/contactos'], selected: false, sideMenu: true },    
    // { canAccess: true, key: 'CONDOMINIOS', icon: 'fa-light fa-building', name: 'Condomínios', nowrap: false, route: '/condominios', routes: ['/condominios/fraccoes', '/condominios/contas', '/condominios/contactos'], selected: false, sideMenu: true },    
    { canAccess: true, key: 'ENTIDADES', icon: 'mdi mdi-account-multiple', name: 'Entidades', nowrap: true, route: '/entidades/proprietario', selected: false, sideMenu: true },
    // { canAccess: true, key: 'ENTIDADES', icon: 'fa-light fa-users', name: 'Entidades', nowrap: true, route: '/entidades/proprietario', selected: false, sideMenu: true },
    { canAccess: true, key: 'ENTIDADES', icon: 'mdi mdi-account-multiple', name: 'Entidades', nowrap: true, route: '/entidades/inquilino', selected: false, sideMenu: false },
    { canAccess: true, key: 'ENTIDADES', icon: 'mdi mdi-account-multiple', name: 'Entidades', nowrap: true, route: '/entidades/fornecedor', selected: false, sideMenu: false },
    { canAccess: true, key: 'ENTIDADES', icon: 'mdi mdi-account-multiple', name: 'Entidades', nowrap: true, route: '/entidades/procurador', selected: false, sideMenu: false },
    { canAccess: true, key: 'ENTIDADES', icon: 'mdi mdi-account-multiple', name: 'Entidades', nowrap: true, route: '/entidades/entidade', selected: false, sideMenu: false },
    
    // { canAccess: true, key: 'ASSEMBLEIAS', icon: 'mdi mdi-briefcase', name: 'Assembleias', nowrap: true, route: '/assembleias', selected: false, sideMenu: true },
    { canAccess: true, key: 'ASSEMBLEIAS', icon: 'mdi mdi-briefcase', name: 'Assembleias', nowrap: true, route: '/assembleias/assembleias', selected: false, sideMenu: true },
    { canAccess: true, key: 'ASSEMBLEIAS', icon: 'mdi mdi-briefcase', name: 'Assembleias', nowrap: true, route: '/assembleias/mapa-reunioes', selected: false, sideMenu: false },
    { canAccess: true, key: 'ASSEMBLEIAS', icon: 'mdi mdi-briefcase', name: 'Assembleias', nowrap: true, route: '/assembleias/agendamentos', selected: false, sideMenu: false },
    { canAccess: true, key: 'ASSEMBLEIAS', icon: 'mdi mdi-briefcase', name: 'Assembleias / Agendamento', nowrap: true, route: '/assembleias/agendamento-assembleias', selected: false, sideMenu: false },
    { canAccess: true, key: 'ASSEMBLEIAS', icon: 'mdi mdi-briefcase', name: 'Assembleias / Assembleia', nowrap: true, route: '/assembleias/assembleias', selected: false, sideMenu: false },
    
    
    { canAccess: true, key: 'ORCAMENTOS', icon: 'mdi mdi-format-list-bulleted', name: 'Orçamentos', nowrap: true, route: '/orcamentos', selected: false, sideMenu: true },
    
    { canAccess: true, key: 'LANCAMENTOS', icon: 'mdi mdi-book-open-page-variant', name: 'Lançamentos', nowrap: true, route: '/lancamentos/despesa', selected: false, sideMenu: true },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'mdi mdi-book-open-page-variant', name: 'Lançamentos', nowrap: true, route: '/lancamentos/aviso', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'mdi mdi-book-open-page-variant', name: 'Lançamentos', nowrap: true, route: '/lancamentos/processamento', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'mdi mdi-book-open-page-variant', name: 'Lançamentos', nowrap: true, route: '/lancamentos/credito', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'mdi mdi-book-open-page-variant', name: 'Lançamentos', nowrap: true, route: '/lancamentos/recibo', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'mdi mdi-book-open-page-variant', name: 'Lançamentos', nowrap: true, route: '/lancamentos/receitas-extra', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'mdi mdi-book-open-page-variant', name: 'Lançamentos', nowrap: true, route: '/lancamentos/pag-quotas', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'mdi mdi-book-open-page-variant', name: 'Lançamentos', nowrap: true, route: '/lancamentos/receita', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'mdi mdi-book-open-page-variant', name: 'Lançamentos', nowrap: true, route: '/lancamentos/agendamento', selected: false, sideMenu: false },
    
    { canAccess: true, key: 'MOVIMENTOS_BANCARIOS', icon: 'mdi mdi-currency-eur', name: 'Finanças', nowrap: true, route: '/movimentosbancarios', selected: false, sideMenu: true },
    
    { canAccess: true, key: 'CAIXA_VERTIS', icon: 'mdi mdi-checkbox-multiple-blank-circle-outline', name: 'Caixa Vertis', nowrap: true, route: '/caixavertis', selected: false, sideMenu: true },
    { canAccess: true, key: 'CAIXA_VERTIS', icon: 'mdi mdi-checkbox-multiple-blank-circle-outline', name: 'Caixa Vertis', nowrap: true, route: '/caixavertis/registo-diario', selected: false, sideMenu: false },
    { canAccess: true, key: 'CAIXA_VERTIS', icon: 'mdi mdi-checkbox-multiple-blank-circle-outline', name: 'Caixa Vertis', nowrap: true, route: '/caixavertis/relatorio', selected: false, sideMenu: false },
        
    
    { canAccess: true, key: 'CONTAS_CORRENTES', icon: 'mdi mdi-cash-multiple', name: 'Contas Correntes', nowrap: true, route: '/contascorrentes', selected: false, sideMenu: true },
    { canAccess: true, key: 'RELATORIOS', icon: 'mdi mdi-note-multiple-outline', name: 'Relatórios', nowrap: true, route: '/relatorios', selected: false, sideMenu: true },

    { canAccess: true, key: 'CONFIGURACOES', icon: 'mdi mdi-cog', name: 'Configurações', nowrap: true, route: '/configuracoes', selected: false, sideMenu: false },
    { canAccess: true, key: 'ACTIVIDADES', icon: 'mdi mdi-format-list-bulleted', name: 'Registo de Atividades', nowrap: true, route: '/actividades', selected: false, sideMenu: false },
    
    { canAccess: true, key: 'ZONAS', icon: 'mdi mdi-home-city-outline', name: 'Condomínios / Zona', nowrap: true, route: '/zonas', selected: false, sideMenu: false },
    { canAccess: true, key: 'FRACCOES', icon: 'mdi mdi-home-city-outline', name: 'Condomínios / Fracção', nowrap: true, route: '/fraccoes', selected: false, sideMenu: false },
    { canAccess: true, key: 'CONTACTOS', icon: 'mdi mdi-home-city-outline', name: 'Condomínios / Contacto', nowrap: true, route: '/contactos', selected: false, sideMenu: false },
    { canAccess: true, key: 'CONTAS', icon: 'mdi mdi-home-city-outline', name: 'Condomínios / Conta', nowrap: true, route: '/contas', selected: false, sideMenu: false },
    { canAccess: true, key: 'CORRESPONDENCIA', icon: 'mdi mdi-email-outline', name: 'Correspondência', nowrap: true, route: '/correspondencia', selected: false, sideMenu: true },
    { canAccess: true, key: 'CORRESPONDENCIA', icon: 'mdi mdi-email-outline', name: 'Correspondência', nowrap: true, route: '/correspondencia/cartascobranca', selected: false, sideMenu: false },
    { canAccess: true, key: 'CORRESPONDENCIA', icon: 'mdi mdi-email-outline', name: 'Correspondência', nowrap: true, route: '/correspondencia/circulares', selected: false, sideMenu: false },


    { canAccess: true, key: 'UTILIZADORES', icon: 'mdi mdi-account-multiple', name: 'Utilizadores', nowrap: true, route: '/utilizadores', selected: false, sideMenu: false },

    { canAccess: false, key: 'PROPOSTAS', icon: 'mdi mdi-account-multiple-plus', name: 'Propostas', nowrap: true, route: '/propostas', selected: false, sideMenu: true },
  ];

  menuArr = [
    { canAccess: true, key: 'CONDOMINIOS', icon: 'ci-light ci-building', name: 'Condomínios', nowrap: false, route: '/condominios', routes: ['/condominios/fraccoes', '/condominios/contas', '/condominios/contactos'], selected: false, sideMenu: true },    
    // { canAccess: true, key: 'CONDOMINIOS', icon: 'fa-light fa-building', name: 'Condomínios', nowrap: false, route: '/condominios', routes: ['/condominios/fraccoes', '/condominios/contas', '/condominios/contactos'], selected: false, sideMenu: true },    
    { canAccess: true, key: 'ENTIDADES', icon: 'ci-light ci-users', name: 'Entidades', nowrap: true, route: '/entidades/proprietario', selected: false, sideMenu: true },
    { canAccess: true, key: 'ENTIDADES', icon: 'ci-light ci-users', name: 'Entidades', nowrap: true, route: '/entidades/inquilino', selected: false, sideMenu: false },
    { canAccess: true, key: 'ENTIDADES', icon: 'ci-light ci-users', name: 'Entidades', nowrap: true, route: '/entidades/fornecedor', selected: false, sideMenu: false },
    { canAccess: true, key: 'ENTIDADES', icon: 'ci-light ci-users', name: 'Entidades', nowrap: true, route: '/entidades/procurador', selected: false, sideMenu: false },
    { canAccess: true, key: 'ENTIDADES', icon: 'ci-light ci-users', name: 'Entidades', nowrap: true, route: '/entidades/entidade', selected: false, sideMenu: false },
    
    // { canAccess: true, key: 'ASSEMBLEIAS', icon: 'mdi mdi-briefcase', name: 'Assembleias', nowrap: true, route: '/assembleias', selected: false, sideMenu: true },
    { canAccess: true, key: 'ASSEMBLEIAS', icon: 'ci-light ci-briefcase', name: 'Assembleias', nowrap: true, route: '/assembleias/assembleias', selected: false, sideMenu: true },
    { canAccess: true, key: 'ASSEMBLEIAS', icon: 'ci-light ci-briefcase', name: 'Assembleias', nowrap: true, route: '/assembleias/mapa-reunioes', selected: false, sideMenu: false },
    { canAccess: true, key: 'ASSEMBLEIAS', icon: 'ci-light ci-briefcase', name: 'Assembleias', nowrap: true, route: '/assembleias/agendamentos', selected: false, sideMenu: false },
    { canAccess: true, key: 'ASSEMBLEIAS', icon: 'ci-light ci-briefcase', name: 'Assembleias / Agendamento', nowrap: true, route: '/assembleias/agendamento-assembleias', selected: false, sideMenu: false },
    { canAccess: true, key: 'ASSEMBLEIAS', icon: 'ci-light ci-briefcase', name: 'Assembleias / Assembleia', nowrap: true, route: '/assembleias/assembleias', selected: false, sideMenu: false },
    
    
    { canAccess: true, key: 'ORCAMENTOS', icon: 'ci-light ci-chart-line-up', name: 'Orçamentos', nowrap: true, route: '/orcamentos', selected: false, sideMenu: true },
    
    { canAccess: true, key: 'LANCAMENTOS', icon: 'ci-light ci-money-check-pen', name: 'Lançamentos', nowrap: true, route: '/lancamentos/despesa', selected: false, sideMenu: true },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'ci-light ci-money-check-pen', name: 'Lançamentos', nowrap: true, route: '/lancamentos/aviso', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'ci-light ci-money-check-pen', name: 'Lançamentos', nowrap: true, route: '/lancamentos/processamento', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'ci-light ci-money-check-pen', name: 'Lançamentos', nowrap: true, route: '/lancamentos/credito', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'ci-light ci-money-check-pen', name: 'Lançamentos', nowrap: true, route: '/lancamentos/recibo', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'ci-light ci-money-check-pen', name: 'Lançamentos', nowrap: true, route: '/lancamentos/receitas-extra', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'ci-light ci-money-check-pen', name: 'Lançamentos', nowrap: true, route: '/lancamentos/pag-quotas', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'ci-light ci-money-check-pen', name: 'Lançamentos', nowrap: true, route: '/lancamentos/receita', selected: false, sideMenu: false },
    { canAccess: true, key: 'LANCAMENTOS', icon: 'ci-light ci-money-check-pen', name: 'Lançamentos', nowrap: true, route: '/lancamentos/agendamento', selected: false, sideMenu: false },
    
    { canAccess: true, key: 'MOVIMENTOS_BANCARIOS', icon: 'ci-light ci-landmark', name: 'Finanças', nowrap: true, route: '/movimentosbancarios', selected: false, sideMenu: true },
    
    { canAccess: true, key: 'CAIXA_VERTIS', icon: 'ci-light ci-hand-holding-dollar', name: 'Caixa Vertis', nowrap: true, route: '/caixavertis', selected: false, sideMenu: true },
    { canAccess: true, key: 'CAIXA_VERTIS', icon: 'ci-light ci-hand-holding-dollar', name: 'Caixa Vertis', nowrap: true, route: '/caixavertis/registo-diario', selected: false, sideMenu: false },
    { canAccess: true, key: 'CAIXA_VERTIS', icon: 'ci-light ci-hand-holding-dollar', name: 'Caixa Vertis', nowrap: true, route: '/caixavertis/relatorio', selected: false, sideMenu: false },
        
    
    { canAccess: true, key: 'CONTAS_CORRENTES', icon: 'ci-light ci-magnifying-glass-chart', name: 'Contas Correntes', nowrap: true, route: '/contascorrentes', selected: false, sideMenu: true },
    { canAccess: true, key: 'RELATORIOS', icon: 'ci-light ci-chart-mixed', name: 'Relatórios', nowrap: true, route: '/relatorios', selected: false, sideMenu: true },

    { canAccess: true, key: 'CONFIGURACOES', icon: 'ci-light ci-gear', name: 'Configurações', nowrap: true, route: '/configuracoes', selected: false, sideMenu: false },
    { canAccess: true, key: 'ACTIVIDADES', icon: 'ci-light ci-wave-pulse', name: 'Registo de Atividades', nowrap: true, route: '/actividades', selected: false, sideMenu: false },
    
    { canAccess: true, key: 'ZONAS', icon: 'mdi mdi-home-city-outline', name: 'Condomínios / Zona', nowrap: true, route: '/zonas', selected: false, sideMenu: false },
    { canAccess: true, key: 'FRACCOES', icon: 'mdi mdi-home-city-outline', name: 'Condomínios / Fracção', nowrap: true, route: '/fraccoes', selected: false, sideMenu: false },
    { canAccess: true, key: 'CONTACTOS', icon: 'mdi mdi-home-city-outline', name: 'Condomínios / Contacto', nowrap: true, route: '/contactos', selected: false, sideMenu: false },
    { canAccess: true, key: 'CONTAS', icon: 'mdi mdi-home-city-outline', name: 'Condomínios / Conta', nowrap: true, route: '/contas', selected: false, sideMenu: false },
    { canAccess: true, key: 'CORRESPONDENCIA', icon: 'ci-light ci-envelope-open-text', name: 'Correspondência', nowrap: true, route: '/correspondencia', selected: false, sideMenu: true },
    { canAccess: true, key: 'CORRESPONDENCIA', icon: 'ci-light ci-envelope-open-text', name: 'Correspondência', nowrap: true, route: '/correspondencia/cartascobranca', selected: false, sideMenu: false },
    { canAccess: true, key: 'CORRESPONDENCIA', icon: 'ci-light ci-envelope-open-text', name: 'Correspondência', nowrap: true, route: '/correspondencia/circulares', selected: false, sideMenu: false },


    { canAccess: true, key: 'UTILIZADORES', icon: 'ci-light ci-users', name: 'Utilizadores', nowrap: true, route: '/utilizadores', selected: false, sideMenu: false },

    { canAccess: false, key: 'PROPOSTAS', icon: 'ci-light ci-file-signature', name: 'Propostas', nowrap: true, route: '/propostas', selected: false, sideMenu: true },
  ];

  assembleiasTipoOpts = [
    { name: 'Todos', value: 'TODOS' },
    { name: 'Ordinária', value: 'ORDINARIA' },
    { name: 'Extra', value: 'EXTRA' },
  ]

  registoProprietarioDividaOpts = [
    { name: 'Desconhecido', value: '0' },
    { name: 'Sem Dívida', value: '1' },
    { name: 'Transição de Dívida', value: '2' },
  ]

  descricaoOpts = [
    'Quotas Orçamento',
    'Quota Extra',
    'Outra (Descrição Livre)',
  ]

  // SELECT ARRAY OPTIONS
  periodicityOpts = [
    { name: 'Manual', value: '0', plural: 'Manuais', monthInc: null, model: [] },
    { name: 'Mensal', value: '1', plural: 'Mensais', monthInc: 1, model: [true,true,true,true,true,true,true,true,true,true,true,true] },
    { name: 'Bimestral', value: '2', plural: 'Bimestrais', monthInc: 2, model: [false,true,false,true,false,true,false,true,false,true,false,true] },
    { name: 'Trimestral', value: '3', plural: 'Trimestral', monthInc: 3, model: [false,false,true,false,false,true,false,false,true,false,false,true] },
    { name: 'Quadrimestral', value: '4', plural: 'Quadrimestrais', monthInc: 4, model: [false,false,false,true,false,false,false,true,false,false,false,true] },
    { name: 'Semestral', value: '5', plural: 'Semestrais', monthInc: 6, model: [false,false,false,false,false,true,false,false,false,false,false,true] },
    { name: 'Anual', value: '6', plural: 'Anuais', monthInc: 12, model: [false,false,false,false,false,false,false,false,false,false,false,true] },
  ];


  tipoEntidadesOpts = [
    { name: 'Administrador', value: 'ADMINISTRADOR' },
    { name: 'Titular bancário', value: 'TITULAR_BANCARIO' },
    { name: 'Outro', value: 'OUTRO' },
  ];

  statusOpts = [
    { name: 'Todos', value: '0' },
    { name: 'Agendamento', value: '1' },
    { name: 'Convocatória', value: '2' },
    { name: 'Assembleias a realizar', value: '9' },
    { name: 'Em elaboração', value: '3' },
    { name: 'Ata concluída', value: '4' },
    { name: 'Em assinatura', value: '5' },
    { name: 'Ata rececionada', value: '8' },
    { name: 'Cópia de ata enviada', value: '6' },
    { name: 'Arquivo digital', value: '7' },
    { name: 'Cancelada', value: '10' },
  ];

  statusAgendamentoOpts = [
    { name: 'Todos', value: '0' },
    { name: 'Em elaboração', value: '1' },
    { name: 'Lançado', value: '2' },
  ];

  daysOfWeekOpts = [
    { name: 'Manual', value: '0', model: [] },
    { name: 'Dias úteis', value: '1', model: [true,true,true,true,true,false,false] },
    { name: 'Todos os dias', value: '2', model: [true,true,true,true,true,true,true] },
  ];

  datePickerWeekDays: Partial<IDatepickerLocaleValues> = {
    weekdaysNarrow: ['D', 'S','T','Q','Q','S','S'],
  };

  formaTratamentoOtps = [
    { name: '', value: '0' },
    { name: 'Arq.', value: '1' },
    { name: 'Arqª.', value: '2' },
    { name: 'Dr.', value: '3' },
    { name: 'Drª.', value: '4' },
    { name: 'Eng.', value: '5' },
    { name: 'Engª.', value: '6' },
    { name: 'Prof.', value: '7' },
    { name: 'Profª.', value: '8' },
    { name: 'Sr.', value: '9' },
    { name: 'Srª.', value: '10' },
    { name: 'Sr/Srª', value: '11' },
  ];

  condClassificacao = [
    { name: 'A', value: 'A' },
    { name: 'B', value: 'B' },
    { name: 'C', value: 'C' },
  ];

  exercicios = [
    // { name: '2019', value: '2019' },
    // { name: '2018', value: '2018' },
    // { name: '2017', value: '2017' },
    // { name: '2016', value: '2016' },
    // { name: '2015', value: '2015' },
    // { name: '2014', value: '2014' },
    // { name: '2013', value: '2013' },
    // { name: '2012', value: '2012' },
  ];

  orcamentoTipoOpts = [
    { name: 'Todos', value: '1' },
    { name: 'Orçamento', value: '2' },
    { name: 'Simulação', value: '3' },
  ]

  pagamentoOtps = [
    { name: 'Numerário', value: '1' },
    { name: 'Transf. Bancária', value: '2' },
    { name: 'Multibanco', value: '3' },
    { name: 'Débito Directo', value: '4' },
    { name: 'Administração (numerário)', value: '6' },
    { name: 'Outra', value: '5' },
  ];

  formaPagamentoOtps = [
    { name: 'Numerário', value: '1' },
    { name: 'Transf. Bancária', value: '2' },
    { name: 'Multibanco', value: '3' },
    { name: 'Débito Directo', value: '4' },
    { name: 'Administração (numerário)', value: '6' },
    { name: 'Outra', value: '4' },
  ];

  isFormaPagamentoCaixa(value) {
    return value == '1' || value == '6';
  }

  tipoCondomino = [
    { name: 'Proprietário', value: '1' },
    { name: 'Inquilino', value: '2' }
  ];

  reparticaoOpts = [
    { name: 'Proporcional', value: 'P' },
    { name: 'Equitativo', value: 'E' },
  ];

  acertosOpts = [
    { name: 'Fundo Reserva', value: '1' },
    { name: 'Manual', value: '0' },
  ];

  processamentosOpts = [
    { name: 'Orçamento', value: 'O' },
    { name: 'Fundo Reserva', value: 'F' },
    { name: 'Extraordinário', value: 'E' },
    { name: 'Seguro', value: 'S' },
    { name: 'Penalizações', value: 'P' },
  ];

  // Condominuims details configs
  orcFRSelOpts = [
    { name: 'Mensal', value: '1' },
    { name: 'Trimestral', value: '2' },
    { name: 'Semestral', value: '3' },
    { name: 'Anual', value: '4' },
    { name: 'Outra', value: '5' },
  ];

  condEstadoOpts = [
    { name: 'Em construção', value: '1' },
    { name: 'Activo', value: '2' },
    { name: 'Inactivo', value: '3' },
  ];

  tipoSeguroOpts = [
    { name: 'Individual', value: '0' },
    { name: 'Colectivo', value: '1' },
  ];

  actQuotasOpts = [
    { name: 'Manual', value: 'M' },
    { name: 'Automático', value: 'A' },
  ];

  calcSelOpts = [
    { name: 'Percentagem', value: 'P' },
    { name: 'Manual', value: 'M' },
  ];

  tipoContactSelOpts = [
    { name: 'Administrador', value: '1' },
    { name: 'Fornecedor', value: '2' },
    { name: 'Outro', value: '3' },
  ];

  tipoContaBancSelOpts = [
    { value: '1', name: 'Conta à ordem' },
    { value: '2', name: 'Conta a prazo' },
    { value: '3', name: 'Conta poupança condomínio' },
    { value: '4', name: 'Conta de uso geral' },
  ];

  exerciciosOpts = [
    { value: '2019', name: '2019' },
    { value: '2018', name: '2018' },
    { value: '2017', name: '2017' },
    { value: '2016', name: '2016' },
    { value: '2015', name: '2015' },
    { value: '2014', name: '2014' },
    { value: '2013', name: '2013' },
    { value: '2012', name: '2012' },
  ];

  devSelOpts = [
    { name: '1', value: '1' },
    { name: '2', value: '2' },
    { name: '3', value: '3' },
    { name: '4', value: '4' },
    { name: '5', value: '5' },
  ];

  condStatesSelOpts = [
    { name: 'Activo', value: '2' },
    { name: 'Construção', value: '1' },
    { name: 'Em angariação', value: '4' },
    { name: 'Em rescisão', value: '5' },
    { name: 'Inactivo', value: '3' },
  ];

  despesasEstadoOpts = [
    { name: 'Todas', value: '0' },
    { name: 'Liquidadas', value: '1' },
    { name: 'Por liquidar', value: '2' },
  ];

  agendamentoEstadoValoresOpts = [
    { name: 'Todos', value: '0' },
    { name: 'Liquidados', value: '1' },
    { name: 'Por liquidar', value: '2' },
  ];

  agendamentoEstadoOpts = [
    { name: 'Inativo', value: '0' },
    { name: 'Ativo', value: '1' },
  ];

  agendamentoEstadoOptsSelect = [
    { name: 'Todos', value: '-1' },
    { name: 'Ativo', value: '1' },
    { name: 'Inativo', value: '0' },
  ];

  creditosEstadoOpts = [
    { name: 'Todas', value: '0' },
    { name: 'Em crédito', value: '1' },
  ];

  // TIPO CONTAS CORRENTES
  tipoAgrupamentoOpts = [
    { name: 'Condómino', value: '1' },
    { name: 'Fracção', value: '0' },
  ];

  tipoListagemOpts = [
    { name: 'Conta corrente', value: '0' },
    { name: 'Valores por liquidar', value: '1' },
    { name: 'Valores liquidados', value: '2' },
  ];

  tipoRelatorioOpts = [
    { name: 'Resumido', value: '0' },
    { name: 'Detalhado', value: '1' },
  ];

  tipoRelatorioExercOpts = [
    { name: 'Balancete', value: '0' },
    { name: 'Listagem Despesas', value: '1' },
    { name: 'Justificação Orçamento', value: '2' },
    { name: 'Resumo Financeiro', value: '3' },
    { name: 'Mapa de Quotas', value: '4' },
    { name: 'Caixas', value: '5' },
    { name: 'Fecho de Contas', value: '6' },
    // { name: 'Relatório de Assembleia', value: '7' },
    // { name: 'Lista de Presenças', value: '8' },
    { name: 'Reconciliação Bancária', value: '9' },
    { name: 'Recibos Anulados', value: '10' },
    { name: 'Listagem Recibos e Despesas', value: '11' },
  ];

  tipoDespesaOpts = [
    { name: 'Despesas', value: 'D' },
    { name: 'Receitas', value: 'R' },
    { name: 'Despesas e receitas', value: 'DR' },
  ];

  tipoDocOpts = [
    { name: 'PDF', value: 'pdf' },
    { name: 'Excel', value: 'csv' },
  ];

  toastr = {
    ownerOfMultipleFracoes: { title: 'Alerta', msg: 'O proprietário da fração escolhida possui mais frações no condomínio escolhido'},
    hasAvisosFromMultipleFracoes: { title: 'Alerta', msg: 'O proprietário da fração escolhida possui avisos em outras frações do condomínio escolhido'},
  }

  errMsg = {
    languageUnsupported: { title: 'Linguagem não suportada', msg: 'Por favor contacte o fornecedor do serviço e/ou tente novamente mais tarde.' },
    apiCall: { title: 'Ups...!', msg: 'Não foi possível efectuar a operação. Por favor, verifique a sua ligação à Internet e/ou tente novamente mais tarde.' },
    unAuth: { title: 'Permissão Negada', msg: 'Não tem permissões para aceder ao recurso/funcionalidade pretendida.' },
    noSelection : { title: 'Ups...!', msg: 'Nenhuma entrada selecionada.' },
    noMovSelection : { title: 'Nenhum movimento selecionado', msg: 'É necessário selecionar pelo menos um movimento.' },
    email: {
      undefinedEmail : { title: 'Ups...!', msg: 'Por favor, preencha o email do destinatário.' },
      unsentEmails : { title: 'Ups...!', msg: 'Não foi possível enviar os emails.' },
    },
    pdf: {
      couldntExportMultiple : { title: 'Ups...!', msg: 'Não foi possível gerar os documentos.' },
      couldntExportOne : { title: 'Ups...!', msg: 'Não foi possível gerar o documento.' },
    },
    reconciliacaoBancaria: {
      notSequenciallyCheck: { title: 'Ups...!', msg: 'Por favor, marque os movimentos que deseja reconciliar, sequencialmente, partindo do movimento mais antigo.' },
      noSelection: { title: 'Nenhum movimento selecionado', msg: 'Por favor, marque os movimentos que deseja reconciliar.' },
      onlyCommunicateAfterReconciliacao: { title: 'Conta em reconciliação bancária', msg: 'O envio do recibo será realizado após a conclusão da reconciliação bancária.' },
    },
    uploadFile: {
      required: { title: 'Selecione um ficheiro', msg: 'Nenhum ficheiro selecionado.' },
      justOneAttachment: { title: 'Selecione apenas um ficheiro', msg: 'Por favor, selecione apenas um ficheiro.' },
      notPossible: { title: 'Erro no upload do(s) ficheiro(s)', msg: 'Não foi possível selecionar o ficheiro pretendido. Por favor, tente novamente.' },
    },
    recibos: {
      cantEdit: { title: 'Ups...!', msg: 'Apenas é possível editar recibos que se encontrem a ser reconciliados por si.' },
    },
    sentEmails: { title: 'Ups...!', msg: 'Ocorreu um erro no envio dos emails.' },
    sentEmail: { title: 'Ups...!', msg: 'Ocorreu um erro no envio do email.' },
    incorrectForm: { title: 'Formulário Incorreto!', msg: 'O formulário está incorreto. Por favor, verifique todos os campos assinalados.' },
  }

  infMsg = {
    exportingPDFs: { title: 'Informação', msg: 'Por favor aguarde, os documentos estão a ser gerados.' },
    exportingPDF: { title: 'Informação', msg: 'Por favor aguarde, o documento está a ser gerado.' },
    fetchingData : { title: 'Informação', msg: 'Por favor aguarde, os dados necessários estão a ser carregados.' },
    entity: {
      noFraccoes: { title: 'Informação', msg: 'A entidade não possui frações.' },
      noFraccoesWithoutContencioso: { title: 'Informação', msg: 'A entidade já se encontra em contencioso para todas as frações que possui.' },
    }
  }

  succMsg = {
    sentRecibos: { title: 'Recibos Enviados', msg: 'Os recibos foram enviados com sucesso.' },
    sentRecibo: { title: 'Recibo Enviado', msg: 'O recibo foi enviado com sucesso.' },
    sentEmails: { title: 'Emails Enviados', msg: 'Os emails foram enviados com sucesso.' },
    sentEmail: { title: 'Email Enviado', msg: 'O email foi enviado com sucesso.' },
  }


  errorCodes = {
    // Geral
    'G_001': { title: 'Não Implementado!', msg: 'Estamos a trabalhar no sentido de implementar a funcionalidade pretendida. Obrigado pela compreensão.' },
    'FORM_ERROR': { title: 'Formulário Incorreto!', msg: 'O formulário está incorreto. Por favor, reveja os respetivos campos.' },
    
    // Reconciliações Bancárias
    'ERR_REC_001': { title: 'Ups...!', msg: 'Por favor, marque os movimentos que deseja reconciliar, sequencialmente, partindo do movimento mais antigo.' },
    'ERR_REC_002': { title: 'Data de reconciliação inválida', msg: 'Só é possível reconciliar movimentos até ontem.' },
    'ERR_REC_003': { title: 'Ups...!', msg: 'Por favor, selecione uma data inferior à data do próximo movimento não reconciliado.' },
    'ERR_REC_004': { title: 'Ups...!', msg: 'Uma parte do período que deseja reconciliar, já se encontra reconciliado. Por favor, atualize a página.' },
    'ERR_REC_005': { title: 'Ups...!', msg: 'A reconciliação já não se encontra em curso. Por favor, atualize a página.' },
    'ERR_REC_006': { title: 'Ups...!', msg: 'A reconciliação em curso está a ser realizada por outro utilizador. Por favor, atualize a página.' },
    'ERR_REC_007': { title: 'Ups...!', msg: 'Não é possível reverter uma reconciliação, pois existe uma reconciliação em curso.' },
    'ERR_REC_008': { title: 'Ups...!', msg: 'O movimento não se encontra reconciliado.' },
    'ERR_REC_009': { title: 'Ups...!', msg: 'A respetiva reconciliação ainda não se encontra finalizada.' },
    'ERR_REC_010': { title: 'Ups...!', msg: 'Apenas é possível reverter movimentos pertencentes à última reconciliação realizada.' },
    'ERR_REC_011': { title: 'Ups...!', msg: 'A data e/ou saldo da reconciliação não coincidem com os inicialmente definidos. ' },
    'ERR_REC_012': { title: 'Período Reconciliado', msg: 'O período no qual deseja introduzir ou alterar um movimento encontra-se reconciliado.' },
    'ERR_REC_013': { title: 'Período em Reconciliação', msg: 'O período no qual deseja introduzir ou alterar um movimento encontra-se atualmente a ser reconciliado por outro utilizador. ' },
    'ERR_REC_014': { title: 'Ups...!', msg: 'A reconciliação indicada não existe. Por favor, atualize a página.' },
    'ERR_REC_015': { title: 'Ups...!', msg: 'Existem movimentos selecionados posteriores à data a reconciliar. Por favor, ajuste a data de reconciliação ou remova os movimentos posteriores à mesma.' },
    'ERR_REC_016': { title: 'Ups...!', msg: 'Não é possível efetuar a comunicação dos avisos e cobrança da reconciliação indicada. A reconciliação não existe ou foi eliminada/cancelada.' },
    'ERR_REC_017': { title: 'Conta principal sem reconciliação', msg: 'Por favor, reconcilie a conta bancária principal para proceder com a operação.' },

    // Recibos
    'ERR_RECIBO_001': { title: 'Ups...!', msg: 'O recibo não existe.' },
    'ERR_RECIBO_002': { title: 'Ups...!', msg: 'Não é possível editar o recibo. Por favor, inicie uma reconciliação bancária se desejar alterá-lo.' },
    'ERR_RECIBO_003': { title: 'Ups...!', msg: 'Não é possível editar o recibo. O período da reconciliação bancária em curso não abrange o recibo.' },
    'ERR_RECIBO_004': { title: 'Ups...!', msg: 'Não é possível editar o recibo. Só é possível editar recibos, caso estes tenham sido pagos via conta bancária.' },
    
    // Despesas
    'ERR_DESP_001': { title: 'Ups...!', msg: 'A data do movimento não pode ser anterior à data da despesa. Por favor, atualize primeiro a data da despesa.' },
    
    // Agendamento
    'ERR_AGENDAMENTO_001': { title: 'Ups...!', msg: 'Não é possível proceder à remoção do agendamento. Já existem despesas com movimentos financeiros associados.' },
    
    // Movimentos
    'ERR_MOV_001': { title: 'Permissão Negada', msg: 'Movimento registado em caixa vertis. Por favor faça o login em caixa vertis primeiro ou contacte o administrador de sistema.' },
    'ERR_MOV_002': { title: 'Permissão Negada', msg: 'Movimento registado em caixa vertis. Por favor contacte o administrador de sistema' },
    
    // Créditos
    'ERR_CREDITO_001': { title: 'Ups...!', msg: 'Não foi possível obter o crédito pretendido.' },
    'ERR_CREDITO_002': { title: 'Ups...!', msg: 'Não é possível eliminar o crédito. O mesmo já foi utilizado.' },
    'ERR_FRACOES_001': { title: 'Ups...!', msg: 'A fração não existe.' },
    'ERR_FRACOES_002': { title: 'Ups...!', msg: 'Não é possível eliminar o registo de proprietário. Único registo de proprietário disponível.' },
    'ERR_FRACOES_003': { title: 'Ups...!', msg: 'O registo de proprietário não existe.' },
    'ERR_FRACOES_004': { title: 'Ups...!', msg: 'Não é possível registar o mesmo proprietário em duas datas seguidas.' },
    'ERR_FRACOES_005': { title: 'Ups...!', msg: 'Já existe um registo de proprietário com início na data indicada.' },
    'ERR_FRACOES_006': { title: 'Ups...!', msg: 'Não é possível registar um proprietário numa data futura.' },
    'ERR_FRACOES_007': { title: 'Ups...!', msg: 'Não é possível proceder à remoção do proprietário. Existem avisos pagos.' },

    // Estados Contenciosos
    'ERR_CONTENCIOSO_001': { title: 'Ups...!', msg: 'Não foi possível obter o estado contencioso pretendido. ' },
    'ERR_CONTENCIOSO_002': { title: 'Ups...!', msg: 'O valor das prestações não perfaz o valor total da dívida do condómino à data indicada.' },
    'ERR_CONTENCIOSO_003': { title: 'Ups...!', msg: 'O proprietário já possui um estado contencioso ativo para a fração indicada.' },
    'ERR_CONTENCIOSO_004': { title: 'Ups...!', msg: 'Não é possível editar o estado contencioso. O mesmo foi removido.' },
    'ERR_CONTENCIOSO_005': { title: 'Ups...!', msg: 'Não é possível editar o estado contencioso. O mesmo foi desativado.' },
    'ERR_CONTENCIOSO_006': { title: 'Ups...!', msg: 'Não foi possível alterar o acordo assinado. É necessário fornecer um motivo.' },
    'ERR_CONTENCIOSO_007': { title: 'Ups...!', msg: 'Não foi possível submeter o estado contencioso. O condómino não possui dívida à data indicada.' },
    
    // Condominos
    'ERR_CONDOMINO_001': { title: 'Ups...!', msg: 'Não é possível definir o envio de documentos por email. O condómino não tem email associado' },
    'ERR_CONDOMINO_002': { title: 'Ups...!', msg: 'É necessário escolher pelo menos um método de envio de documentos por cada tipo de documento.' },
    'ERR_CONDOMINO_003': { title: 'Ups...!', msg: 'Não foi possível definir o método de envio de documentos. O método não existe.' },
    'ERR_CONDOMINO_004': { title: 'Ups...!', msg: 'O condómino não tem número de contribuinte definido. Por favor, preencha o respetivo campo na ficha do condómino antes de continuar.' },
    'ERR_CONDOMINO_005': { title: 'Ups...!', msg: 'O condómino não tem morada definida. Por favor, preencha o respetivo campo na ficha do condómino antes de continuar.' },
    
    // Textos
    'ERR_TEXTOS_001': { title: 'Ups...!', msg: 'O texto definido não existe. Por favor, defina um outro texto.' },

    'ERR_TEXTOS_BIND_001': { title: 'Ups...!', msg: 'O texto a enviar necessita de reconciliação bancária efetuada, no entanto nunca se efetuaram reconciliações bancárias.' },
    'ERR_TEXTOS_BIND_002': { title: 'Ups...!', msg: 'O texto a enviar necessita de um advogado definido. Por favor, indique o respetivo advogado no estado contencioso.' },
    'ERR_TEXTOS_BIND_003': { title: 'Ups...!', msg: 'O texto a enviar necessita de um agente de execução definido. Por favor, indique o respetivo agente de execução no estado contencioso.' },
    
    // Relatórios
    'ERR_RELATORIO_CONF_DIVIDA_001': { title: 'Ups...!', msg: 'Não é possível emitir o documento, visto não haver orçamento lançado para a fração e data selecionadas.' },
    
    // Orçamentos
    'ERR_ORCAMENTO_001': { title: 'Ups...!', msg: 'O orçamento selecionado já possui avisos pagos. Por favor, proceda primeiro à anulação dos respetivos recibos.' },
    
    // Assembleias
    'ERR_ASSEMBLEIAS_PRESENCAS_001': { title: 'Ups...!', msg: 'Não é possível guardar a assinatura de um condómino que não esteve presente em assembleia. Por favor, reveja as assinaturas da ata.' },
    
    'ERR_ASSEMBLEIAS_002': { title: 'Ups...!', msg: 'Existe um erro na ordem de trabalho "Bancos", por favor submeta de novo as respostas à mesma.' },
    'ERR_ASSEMBLEIAS_003': { title: 'Ups...!', msg: 'Não é possível eliminar a ordem de trabalho, pois a conta criada previamente nesta ata tem movimentos associados.' },
    
    // Assembleias
    'CONDOMINIO_ENTIDADES_001': { title: 'Ups...!', msg: 'Não é possível remover a entidade, visto a mesma estar registada em ata.' },
    'TITULAR_BANCARIO_001': { title: 'Ups...!', msg: 'Não é possível definir os titulares bancários como estando em funções, visto que a assembleia não tem quórum.' },
    

  }

  infoCodes = {
    'INFO_REC_001': { title: 'Informação', msg: 'A conta selecionada já se encontra reconciliada até ontem. Por favor, aguarde até o fecho do dia para reconciliar os movimentos de hoje.' },
  }

  warningCodes = {
    'WARN_REC_001': { title: 'Atenção', msg: 'O movimento selecionado encontra-se a ser reconciliado por outro utilizador.' },
    'WARN_REC_002': { title: 'Atenção', msg: 'O movimento encontra-se a ser reconciliado por si.' },
  }

  // CAIXA VERTIS CONFIGS ---------------------------------------------------------------------
  caixaVertisTipoMovOtps = [
    { name: 'Crédito', value: 'C' },
    { name: 'Débito', value: 'D' },
  ];

  // caixaVertisDescricaoOtps = [
  //   { name: 'Reforço Caixa', value: 'REFORCO_CAIXA', tipoMov: 'C' },
  //   { name: 'Saída Caixa', value: 'SAIDA_CAIXA', tipoMov: 'D' },
  //   { name: 'Vales Limpeza', value: 'VALE_LIMPEZA', tipoMov: 'D' },
  //   { name: 'Conservatória', value: 'CONSERVATORIA', tipoMov: 'D' },
  //   { name: 'Entrega Valores Ctt', value: 'CTT', tipoMov: 'D' },
  //   { name: 'Fatura Ctt', value: 'FACTURA_CTT', tipoMov: 'C' },
  //   { name: 'Entrega Valores Vera', value: 'ENTREGA_VERA', tipoMov: 'D' },
  //   { name: 'Entrega Valores Sérgio', value: 'ENTREGA_SERGIO', tipoMov: 'D' },
  //   { name: 'Entrega Fecho de Caixa Vera', value: 'FECHO_CAIXA_VERA', tipoMov: 'D' },
  //   { name: 'Entrega Fecho de Caixa Sérgio', value: 'FECHO_CAIXA_SERGIO', tipoMov: 'D' },
  //   { name: 'Outro', value: 'INPUT_TEXT', tipoMov: null },
  // ];

  caixaVertisDescricaoOtps = [
    { name: 'Reforço Caixa', value: 'REFORCO_CAIXA', tipoMov: 'C' },

    { name: 'Recebimentos de Valores', value: 'RECEBIMENTO_VALORES', tipoMov: 'C' },  // PARA O PREDIO - TEM DE GERAR UMA DECLARAÇÂO

    { name: 'Vales Limpeza', value: 'VALE_LIMPEZA', tipoMov: 'D' },

    { name: 'Entrega Valores CRP', value: 'CONSERVATORIA', tipoMov: 'D' },
    { name: 'Fatura CRP', value: 'FACTURA_CONSERVATORIA', tipoMov: 'C' },

    { name: 'Entrega Valores Ctt', value: 'CTT', tipoMov: 'D' },
    { name: 'Fatura Ctt', value: 'FACTURA_CTT', tipoMov: 'C' },

    { name: 'Entrega Valores', value: 'ENTREGA_VALORES', tipoMov: 'D' },

    { name: 'Entrega Valores para Cofre', value: 'ENTREGA_VALORES_COFRE', tipoMov: 'D' },
    { name: 'Receção Valores de Cofre', value: 'RECEBIMENTO_VALORES_COFRE', tipoMov: 'C' },

    { name: 'Entrega Fecho de Caixa', value: 'ENTREGA_VALORES_CAIXA', tipoMov: 'D' },

    { name: 'Outro', value: 'INPUT_TEXT', tipoMov: null },
  ];
  // ------------------------------------------------------------------------------------------

  // CAIXA VERTIS CONFIGS ---------------------------------------------------------------------
  condominosOpts = [
    { name: 'Todos os condóminos', value: 'TODOS' },
    { name: 'Restantes condóminos', value: 'RESTANTES' },
    { name: 'Descrição Livre', value: 'DESCRICAO' },
    { name: 'Manual', value: 'MANUAL' },
  ];
  // CAIXA VERTIS -----------------------------------------------------------------------------


  // EMAILS CONFIGURATION / SETUP
  company = {
    nome: 'VERTIS - Gestão Condomínios',
    morada: 'Rua Joaquim Valentim Correia, nº 14 A',
    localidade: 'Vale de Gatos - Cruz de Pau',
    codigoPostal: '2845-568 Amora',
    tel: '21 820 11 91',
    email: 'geral@vertis.pt',
    emailFromName: 'VERTIS - Gestão Condomínios',
    website: 'www.vertis.pt',
  }

  // EMAIL CONFIGS FROM API
  mapaDeQuotasEmailSubject = '';
  mapaDeQuotasEmailAnexoBody = [];

  avisoDePagamentoEmailSubject = '';
  avisoDePagamentoEmailBody = [];

  contaCorrenteEmailSubject = '';
  contaCorrenteEmailBody = [];

  recibosCreditosEmailSubject = '';
  recibosCreditosEmailBody = [];

  recibosEmailSubject = '';
  recibosEmailBody = [];

  creditosEmailSubject = '';
  creditosEmailBody = [];

  ataAnexoSubject = '';
  ataAnexoBody = [];

  ataEntreguePresencialmenteSubject = '';
  ataEntreguePresencialmenteBody = [];

  creditosStateOpts = [
    { name: 'Valores em crédito', value: 'VALOR_EM_CREDITO' },
    { name: 'Todos', value: 'ALL' }
  ];

  reciboBody = [
    'Bom dia,',
    '',
    'Junto enviamos o recibo, conforme pagamento efectuado.',
    '',
    'Solicita-se que o envio de comprovativo de pagamento de quotas de condomínio, seja efectuado para o e-mail geral <a href="mailto:' + this.company.email + '">' + this.company.email + '</a>.'
  ];

  convocatoriaBody = [
    'Bom dia,',
    '',
    'Junto enviamos a convocatória para a próxima assembleia de condóminos a realizar na data indicada.',
  ];

  ataAssinadaSubject = 'Envio de Ata Assinada da última Assembleia';
  ataAssinadaBody = [
    'Bom dia,',
    '',
    'Junto enviamos a cópia da ata assinada da assembleia de condóminios realizada na data indicada.',
  ];

  reciboAnuladoBody = [
    'Bom dia,',
    '',
    'Junto enviamos o comprovativo de anulação do recibo.'
  ];

  caixaVertisBody = [
    'Bom dia,',
    '',
    'Junto enviamos em anexo, o relatório de Caixa Vertis do dia à hora de fecho.',
  ];

  creditoBody = [
    'Bom dia,',
    '',
    'Junto enviamos o comprovativo de crédito, conforme pagamento efectuado.',
  ];

  despesaBody = [
    'Bom dia,',
    '',
    'Junto enviamos o comprovativo de despesa, conforme pagamento efectuado.',
  ];

  receitaBody = [
    'Bom dia,',
    '',
    'Junto enviamos o comprovativo de receita, conforme pagamento efectuado.',
  ];

  // PERMISSION OBJECT ------------------------------------------------------------------------ 
  permissionAccessObg = [{"key":"CONDOMINIOS","entityName":"Condominios","access":{"create":true,"read":true,"update":false,"delete":false,}},{"key":"ENTIDADES","entityName":"Entidades","access":{"create":true,"read":true,"update":false,"delete":false,}},{"key":"ORCAMENTOS","entityName":"Orçamentos","access":{"create":true,"read":true,"update":false,"delete":false,}},{"key":"DESPESAS","entityName":"Despesas","access":{"create":true,"read":true,"update":false,"delete":false,}},{"key":"RECEBIMENTOS","entityName":"Recebimentos","access":{"create":true,"read":true,"update":false,"delete":false,}},{"key":"CREDITOS","entityName":"Créditos","access":{"create":true,"read":true,"update":false,"delete":false,}},{"key":"RECEITA_EXTRA","entityName":"Receita Extra","access":{"create":true,"read":true,"update":false,"delete":false,}},{"key":"RECIBOS","entityName":"Recibos","access":{"create":true,"read":true,"update":false,"delete":false,}},{"key":"AVISOS","entityName":"Avisos","access":{"create":true,"read":true,"update":false,"delete":false,}},{"key":"PROCESSAMENTOS","entityName":"Processamentos","access":{"create":true,"read":true,"update":false,"delete":false,}},{"key":"MOVIMENTOS_BANCARIOS","entityName":"Movimentos Financeiros","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"CONTAS_CORRENTES","menuName":"Contas Correntes","key":"CONTAS_CORRENTES_FRACCOES","entityName":"Fraccões","access":{"create":false,"read":true,"update":false,"delete":false,}},{"menuKey":"CONTAS_CORRENTES","menuName":"Contas Correntes","key":"CONTAS_CORRENTES_CONDOMINOS","entityName":"Condóminos","access":{"create":false,"read":true,"update":false,"delete":false,}},{"menuKey":"CONTAS_CORRENTES","menuName":"Contas Correntes","key":"CONTAS_CORRENTES_FORNECEDORES","entityName":"Fornecedores","access":{"create":false,"read":true,"update":false,"delete":false,}},{"menuKey":"RELATORIOS","menuName":"Relatórios","key":"BALANCETE","entityName":"Balancete","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"RELATORIOS","menuName":"Relatórios","key":"LISTAGEM_DESPESAS","entityName":"Listagem Despesas","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"RELATORIOS","menuName":"Relatórios","key":"JUSTIFICACAO_ORCAMENTO","entityName":"Justificação Orçamento","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"RELATORIOS","menuName":"Relatórios","key":"RESUMO_FINANCEIRO","entityName":"Resumo Financeiro","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"RELATORIOS","menuName":"Relatórios","key":"MAPA_QUOTAS","entityName":"Mapa de Quotas","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"RELATORIOS","menuName":"Relatórios","key":"CAIXAS","entityName":"Caixas","access":{"create":true,"read":true,"update":false,"delete":false,}},{"key":"CORRESPONDENCIA","entityName":"Correspondência","access":{"create":true,"read":true,"update":false,"delete":false,}},{"key":"ASSEMBLEIAS","entityName":"Assembleias","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"CONFIGURACOES","menuName":"Configurações","key":"RUBRICAS","entityName":"Rubricas","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"CONFIGURACOES","menuName":"Configurações","key":"TEXTOS","entityName":"Textos","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"CONFIGURACOES","menuName":"Configurações","key":"SERVICOS","entityName":"Serviços","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"CONFIGURACOES","menuName":"Configurações","key":"OCORRENCIAS","entityName":"Ocorrências","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"CONFIGURACOES","menuName":"Configurações","key":"INTERVENCOES","entityName":"Intervenções","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"CONFIGURACOES","menuName":"Configurações","key":"ACCOES","entityName":"Acções","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"CONFIGURACOES","menuName":"Configurações","key":"EQUIPAMENTOS","entityName":"Equipamentos","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"CONFIGURACOES","menuName":"Configurações","key":"CONTAS","entityName":"Contas","access":{"create":true,"read":true,"update":false,"delete":false,}},{"menuKey":"CONFIGURACOES","menuName":"Configurações","key":"DOC_ASSEMBLEIAS","entityName":"Doc. Assembleias","access":{"create":true,"read":true,"update":true,"delete":true}},{"menuKey":"CONFIGURACOES","menuName":"Configurações","key":"ORDEM_TRABALHOS","entityName":"Ordem Trabalhos","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"CAIXA_VERTIS","entityName":"Caixa Vertis","access":{"create":true,"read":true,"update":false,"delete":false,}}];

  permissionAccessOpts = [
    { name: '', value: '0', model: []},
    { name: 'Utilizador', value: '2', model: [{"key":"CONDOMINIOS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"ENTIDADES","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"ORCAMENTOS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"DESPESAS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"DESPESA_PAYMENT","access":{}},{"key":"RECEBIMENTOS","access":{"create":true,"read":true}},{"key":"CREDITOS","access":{"create":true,"read":true,"update":false,"delete":false,"allow":false}},{"key":"RECEITA_EXTRA","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"RECIBOS","access":{"create":true,"read":true,"delete":false}},{"key":"AVISOS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"PROCESSAMENTOS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"FINANCAS","access":{"create":false,"read":true,"update":false,"delete":false,"allow":false}},{"key":"MOVIMENTOS_BANCARIOS","access":{"create":true,"read":true,"update":false,"delete":false,"allow":false}},{"key":"RECONCILIACOES_BANCARIAS","access":{"read":true,"create":false,"delete":false,"allow":false}},{"key":"RECONCILIACOES_BANCARIAS_VIEW_CURRENT","access":{"allow":false}},{"key":"RECONCILIACOES_BANCARIAS_VIEW_REG_ATIVIDADE","access":{"allow":false}},{"key":"RECONCILIACOES_BANCARIAS_OTHER_USER_CONTINUE","access":{"allow":false}},{"key":"RECONCILIACOES_BANCARIAS_CHANGE_MOVEMENTS_EM_CURSO","access":{"allow":false}},{"key":"CONTAS_CORRENTES","access":{"read":true}},{"key":"CONTAS_CORRENTES_FRACCOES","access":{"read":true}},{"key":"CONTAS_CORRENTES_CONDOMINOS","access":{"read":true}},{"key":"CONTAS_CORRENTES_FORNECEDORES","access":{"read":true}},{"key":"RELATORIOS","access":{"read":true}},{"key":"BALANCETE","access":{"read":true}},{"key":"LISTAGEM_DESPESAS","access":{"read":true}},{"key":"JUSTIFICACAO_ORCAMENTO","access":{"read":true}},{"key":"RESUMO_FINANCEIRO","access":{"read":true}},{"key":"MAPA_QUOTAS","access":{"read":true}},{"key":"CAIXAS","access":{"read":true}},{"key":"CORRESPONDENCIA","access":{"create":true,"read":true,"delete":false,"allow":false}},{"key":"CORRESPONDENCIA_AC","access":{"read":true,"create":true}},{"key":"CORRESPONDENCIA_C","access":{"read":true,"create":true,"allow":false}},{"key":"CORRESPONDENCIA_C_COPIAR_EMAILS","access":{"allow":false}},{"key":"CORRESPONDENCIA_C_ASSINAR_POR_TODOS","access":{"allow":false}},{"key":"CORRESPONDENCIA_RC","access":{"read":true,"delete":false}},{"key":"CORRESPONDENCIA_CC","access":{"read":true,"delete":false,"allow":false}},{"key":"CORRESPONDENCIA_CC_REMOVE_REGISTO_ASSOCIADO","access":{"allow":false}},{"key":"CORRESPONDENCIA_CC_VER_DETALHE_CUSTO_INDIVIDUAL","access":{"allow":false}},{"key":"CORRESPONDENCIA_CC_VER_DETALHE_CUSTO_TOTAL","access":{"allow":false}},{"key":"ASSEMBLEIAS","access":{"create":true,"read":true,"update":false,"delete":false,"allow":false}},{"key":"ASSEMBLEIAS_ATA","access":{"allow":false}},{"key":"UPLOAD_ATA_AFTER_SENT","access":{"allow":false}},{"key":"DELETE_ATA_AFTER_SENT","access":{"allow":false}},{"key":"CAIXA_VERTIS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"PROPOSTAS","access":{"read":false,"update":false,"delete":false}},{"key":"CONFIGURACOES","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"RUBRICAS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"TEXTOS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"BANCOS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"CONTAS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"DOC_ASSEMBLEIAS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"ORDEM_TRABALHOS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"CONFIGURACOES_EMAILS","access":{"create":true,"read":true,"update":false,"delete":false}},{"key":"CONFIGURACOES_MINUTAS","access":{"create":true,"read":true,"update":false,"delete":false}}] },
    { name: 'Utilizador Médio', value: '3', model: [{"key":"CONDOMINIOS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"ENTIDADES","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"ORCAMENTOS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"DESPESAS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"DESPESA_PAYMENT","access":{}},{"key":"RECEBIMENTOS","access":{"create":true,"read":true}},{"key":"CREDITOS","access":{"create":true,"read":true,"update":true,"delete":false,"allow":true}},{"key":"RECEITA_EXTRA","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"RECIBOS","access":{"create":true,"read":true,"delete":false}},{"key":"AVISOS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"PROCESSAMENTOS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"FINANCAS","access":{"create":false,"read":true,"update":false,"delete":false,"allow":false}},{"key":"MOVIMENTOS_BANCARIOS","access":{"create":true,"read":true,"update":true,"delete":false,"allow":false}},{"key":"RECONCILIACOES_BANCARIAS","access":{"read":true,"create":false,"delete":false,"allow":false}},{"key":"RECONCILIACOES_BANCARIAS_VIEW_CURRENT","access":{"allow":false}},{"key":"RECONCILIACOES_BANCARIAS_VIEW_REG_ATIVIDADE","access":{"allow":false}},{"key":"RECONCILIACOES_BANCARIAS_OTHER_USER_CONTINUE","access":{"allow":false}},{"key":"RECONCILIACOES_BANCARIAS_CHANGE_MOVEMENTS_EM_CURSO","access":{"allow":false}},{"key":"CONTAS_CORRENTES","access":{"read":true}},{"key":"CONTAS_CORRENTES_FRACCOES","access":{"read":true}},{"key":"CONTAS_CORRENTES_CONDOMINOS","access":{"read":true}},{"key":"CONTAS_CORRENTES_FORNECEDORES","access":{"read":true}},{"key":"RELATORIOS","access":{"read":true}},{"key":"BALANCETE","access":{"read":true}},{"key":"LISTAGEM_DESPESAS","access":{"read":true}},{"key":"JUSTIFICACAO_ORCAMENTO","access":{"read":true}},{"key":"RESUMO_FINANCEIRO","access":{"read":true}},{"key":"MAPA_QUOTAS","access":{"read":true}},{"key":"CAIXAS","access":{"read":true}},{"key":"CORRESPONDENCIA","access":{"create":true,"read":true,"delete":false,"allow":false}},{"key":"CORRESPONDENCIA_AC","access":{"read":true,"create":true}},{"key":"CORRESPONDENCIA_C","access":{"read":true,"create":true,"allow":false}},{"key":"CORRESPONDENCIA_C_COPIAR_EMAILS","access":{"allow":false}},{"key":"CORRESPONDENCIA_C_ASSINAR_POR_TODOS","access":{"allow":false}},{"key":"CORRESPONDENCIA_RC","access":{"read":true,"delete":false}},{"key":"CORRESPONDENCIA_CC","access":{"read":true,"delete":false,"allow":false}},{"key":"CORRESPONDENCIA_CC_REMOVE_REGISTO_ASSOCIADO","access":{"allow":false}},{"key":"CORRESPONDENCIA_CC_VER_DETALHE_CUSTO_INDIVIDUAL","access":{"allow":false}},{"key":"CORRESPONDENCIA_CC_VER_DETALHE_CUSTO_TOTAL","access":{"allow":false}},{"key":"ASSEMBLEIAS","access":{"create":true,"read":true,"update":true,"delete":false,"allow":false}},{"key":"ASSEMBLEIAS_ATA","access":{"allow":false}},{"key":"UPLOAD_ATA_AFTER_SENT","access":{"allow":false}},{"key":"DELETE_ATA_AFTER_SENT","access":{"allow":false}},{"key":"CAIXA_VERTIS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"PROPOSTAS","access":{"read":false,"update":false,"delete":false}},{"key":"CONFIGURACOES","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"RUBRICAS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"TEXTOS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"BANCOS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"CONTAS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"DOC_ASSEMBLEIAS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"ORDEM_TRABALHOS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"CONFIGURACOES_EMAILS","access":{"create":true,"read":true,"update":true,"delete":false}},{"key":"CONFIGURACOES_MINUTAS","access":{"create":true,"read":true,"update":true,"delete":false}}]},
    { name: 'Supervisor', value: '1', model: [{"key":"CONDOMINIOS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"ENTIDADES","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"ORCAMENTOS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"DESPESAS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"DESPESA_PAYMENT","access":{}},{"key":"RECEBIMENTOS","access":{"create":true,"read":true}},{"key":"CREDITOS","access":{"create":true,"read":true,"update":true,"delete":true,"allow":true}},{"key":"RECEITA_EXTRA","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"RECIBOS","access":{"create":true,"read":true,"delete":true}},{"key":"AVISOS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"PROCESSAMENTOS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"FINANCAS","access":{"create":true,"read":true,"update":true,"delete":true,"allow":true}},{"key":"MOVIMENTOS_BANCARIOS","access":{"create":true,"read":true,"update":true,"delete":true,"allow":true}},{"key":"RECONCILIACOES_BANCARIAS","access":{"read":true,"create":true,"delete":true,"allow":true}},{"key":"RECONCILIACOES_BANCARIAS_VIEW_CURRENT","access":{"allow":true}},{"key":"RECONCILIACOES_BANCARIAS_VIEW_REG_ATIVIDADE","access":{"allow":true}},{"key":"RECONCILIACOES_BANCARIAS_OTHER_USER_CONTINUE","access":{"allow":true}},{"key":"RECONCILIACOES_BANCARIAS_CHANGE_MOVEMENTS_EM_CURSO","access":{"allow":true}},{"key":"CONTAS_CORRENTES","access":{"read":true}},{"key":"CONTAS_CORRENTES_FRACCOES","access":{"read":true}},{"key":"CONTAS_CORRENTES_CONDOMINOS","access":{"read":true}},{"key":"CONTAS_CORRENTES_FORNECEDORES","access":{"read":true}},{"key":"RELATORIOS","access":{"read":true}},{"key":"BALANCETE","access":{"read":true}},{"key":"LISTAGEM_DESPESAS","access":{"read":true}},{"key":"JUSTIFICACAO_ORCAMENTO","access":{"read":true}},{"key":"RESUMO_FINANCEIRO","access":{"read":true}},{"key":"MAPA_QUOTAS","access":{"read":true}},{"key":"CAIXAS","access":{"read":true}},{"key":"CORRESPONDENCIA","access":{"create":true,"read":true,"delete":true,"allow":true}},{"key":"CORRESPONDENCIA_AC","access":{"read":true,"create":true}},{"key":"CORRESPONDENCIA_C","access":{"read":true,"create":true,"allow":true}},{"key":"CORRESPONDENCIA_C_COPIAR_EMAILS","access":{"allow":true}},{"key":"CORRESPONDENCIA_C_ASSINAR_POR_TODOS","access":{"allow":true}},{"key":"CORRESPONDENCIA_RC","access":{"read":true,"delete":true}},{"key":"CORRESPONDENCIA_CC","access":{"read":true,"delete":true,"allow":true}},{"key":"CORRESPONDENCIA_CC_REMOVE_REGISTO_ASSOCIADO","access":{"allow":true}},{"key":"CORRESPONDENCIA_CC_VER_DETALHE_CUSTO_INDIVIDUAL","access":{"allow":true}},{"key":"CORRESPONDENCIA_CC_VER_DETALHE_CUSTO_TOTAL","access":{"allow":true}},{"key":"ASSEMBLEIAS","access":{"create":true,"read":true,"update":true,"delete":true,"allow":true}},{"key":"ASSEMBLEIAS_ATA","access":{"allow":true}},{"key":"UPLOAD_ATA_AFTER_SENT","access":{"allow":true}},{"key":"DELETE_ATA_AFTER_SENT","access":{"allow":true}},{"key":"CAIXA_VERTIS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"PROPOSTAS","access":{"read":false,"update":false,"delete":false}},{"key":"CONFIGURACOES","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"RUBRICAS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"TEXTOS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"BANCOS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"CONTAS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"DOC_ASSEMBLEIAS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"ORDEM_TRABALHOS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"CONFIGURACOES_EMAILS","access":{"create":true,"read":true,"update":true,"delete":true}},{"key":"CONFIGURACOES_MINUTAS","access":{"create":true,"read":true,"update":true,"delete":true}}]},
  ];
  // PERMISSION OBJECT ------------------------------------------------------------------------ 

  
  constructor(
      public userSession: UserSessionService,
      ) {
    switch (this.envMode) {
      case 'PRODUCTION':
        this.fileProxyUrl = 'https://condominios.vertisprime.pt/api.vertisprime.pt/public/proxy-server.php';
        this.emailLogoUrl = 'https://condominios.vertisprime.pt/assets/img/vertis-logo-inverted.png';
        break;
      case 'TESTING':
        this.fileProxyUrl = 'https://63-250-57-22.cloud-xip.com/primo-api/public/test/proxy-server.php';
        this.emailLogoUrl = 'https://63-250-57-22.cloud-xip.com/assets/img/vertis-logo-inverted.png';
        break;
      case 'DEVELOPMENT':
        this.fileProxyUrl = 'https://63-250-57-22.cloud-xip.com/primo-api/public/proxy-server.php';
        this.emailLogoUrl = 'https://63-250-57-22.cloud-xip.com/assets/img/vertis-logo-inverted.png';
        break;
    }

    let thisYear = Number((new Date()).getFullYear());
    this.exercicios = [];
    while (thisYear >= 2012) {
      this.exercicios.push({ name: thisYear.toString(), value: thisYear.toString() });
      thisYear--;
    }

    this.exerciciosOpts = JSON.parse(JSON.stringify(this.exercicios));

    // ADD PAYMENT ENTRY TO PERMISSION OBJECT
    this.permissionAccessOpts.forEach(el => {
      el.model.forEach(it => {
        switch (it.key) {
          case 'DESPESAS':
            it.access['payment'] = (el.value !== '0' && el.value !== '2');
            break;
          case 'CREDITOS':
            it.access['payment'] = (el.value !== '0' && el.value !== '2');
            break;
          default:
            it.access['payment'] = false;
        }
      })
    });
    
  }

  updateCompanyInfo(info: companyInfo) {
    this.company = info;
  }

  getSideMenuEntries() {
    return this.menuArr.filter(el => (el.sideMenu));
  }
}
